import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Mail, MapPin, Phone } from 'lucide-react';
export function Footer() {
  return <footer className="bg-brand-dark text-white pt-20 pb-10" data-id="element-74">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-75">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-76">
          {/* Brand */}
          <div className="lg:col-span-1" data-id="element-77">
            <Link to="/" className="inline-block" data-id="element-78">
              <img src="https://cdn.magicpatterns.com/uploads/aqfFtawQLdvdgEuWf1RLRX/ColorGREENTransperant.png" alt="Capsin - Authentiek genieten" className="h-16 w-auto object-contain mb-6 bg-white/90 rounded-lg p-2" data-id="element-79" />
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed mb-6" data-id="element-80">
              Authentiek genieten van de enige echte smaakmaker. Puur,
              natuurlijk en vol passie bereid.
            </p>
            <div className="flex gap-4" data-id="element-81">
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-brand-red transition-colors" data-id="element-82">
                <Instagram size={18} data-id="element-83" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-brand-red transition-colors" data-id="element-84">
                <Facebook size={18} data-id="element-85" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-86">
            <h4 className="font-serif font-bold text-lg mb-6" data-id="element-87">Shop</h4>
            <ul className="space-y-4 text-gray-400 text-sm" data-id="element-88">
              <li data-id="element-89">
                <Link to="/shop" className="hover:text-brand-orange transition-colors" data-id="element-90">
                  Alle Producten
                </Link>
              </li>
              <li data-id="element-91">
                <Link to="/product/madame-jeanette-peper-vlokken" className="hover:text-brand-orange transition-colors" data-id="element-92">
                  Madame Jeanette
                </Link>
              </li>
              <li data-id="element-93">
                <Link to="/product/fong-fong-pepre" className="hover:text-brand-orange transition-colors" data-id="element-94">
                  Fong Fong Pepre
                </Link>
              </li>
              <li data-id="element-95">
                <Link to="/#retailers" className="hover:text-brand-orange transition-colors" data-id="element-96">
                  Verkooppunten
                </Link>
              </li>
            </ul>
          </div>

          {/* Info */}
          <div data-id="element-97">
            <h4 className="font-serif font-bold text-lg mb-6" data-id="element-98">Informatie</h4>
            <ul className="space-y-4 text-gray-400 text-sm" data-id="element-99">
              <li data-id="element-100">
                <Link to="/#story" className="hover:text-brand-orange transition-colors" data-id="element-101">
                  Over Ons
                </Link>
              </li>
              <li data-id="element-102">
                <Link to="/contact" className="hover:text-brand-orange transition-colors" data-id="element-103">
                  Contact
                </Link>
              </li>
              <li data-id="element-104">
                <a href="#" className="hover:text-brand-orange transition-colors" data-id="element-105">
                  Verzending &amp; Retour
                </a>
              </li>
              <li data-id="element-106">
                <a href="#" className="hover:text-brand-orange transition-colors" data-id="element-107">
                  Algemene Voorwaarden
                </a>
              </li>
              <li data-id="element-108">
                <a href="#" className="hover:text-brand-orange transition-colors" data-id="element-109">
                  Privacy Policy
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-110">
            <h4 className="font-serif font-bold text-lg mb-6" data-id="element-111">Contact</h4>
            <ul className="space-y-4 text-gray-400 text-sm" data-id="element-112">
              <li className="flex items-start gap-3" data-id="element-113">
                <Mail size={18} className="text-brand-orange flex-shrink-0 mt-0.5" data-id="element-114" />
                <a href="mailto:info@capsin.nl" className="hover:text-brand-orange transition-colors" data-id="element-115">
                  info@capsin.nl
                </a>
              </li>
              <li className="flex items-start gap-3" data-id="element-116">
                <Phone size={18} className="text-brand-orange flex-shrink-0 mt-0.5" data-id="element-117" />
                <a href="tel:0615123933" className="hover:text-brand-orange transition-colors" data-id="element-118">
                  06 15 12 39 33
                </a>
              </li>
              <li className="flex items-start gap-3" data-id="element-119">
                <MapPin size={18} className="text-brand-orange flex-shrink-0 mt-0.5" data-id="element-120" />
                <span data-id="element-121">
                  Capsin International
                  <br data-id="element-122" />
                  Nederland
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-gray-500" data-id="element-123">
          <p data-id="element-124">
            © {new Date().getFullYear()} Capsin International. Alle rechten
            voorbehouden.
          </p>
          <div className="flex gap-4" data-id="element-125">
            <span data-id="element-126">KVK: 12345678</span>
            <span data-id="element-127">BTW: NL123456789B01</span>
          </div>
        </div>
      </div>
    </footer>;
}